import React from 'react'
import { Text } from '../Text'
import { IProps } from './index'
import { BrandOptions, useBrand } from '../../providers/brandProvider'
import { FooterHeadingLink as FooterHeadingLinkDefault } from './component'

export const FooterHeadingLink = (props: IProps): React.ReactElement => {
  const theme = useBrand()
  if (theme === BrandOptions.default) {
    return <FooterHeadingLinkDefault {...props} />
  }
  return <FooterHeadingLinkLegacy {...props} />
}

export const FooterHeadingLinkLegacy = ({ text, url }: IProps): React.ReactElement => {
  return (
    <>
      <a href={url} className="footer__link">
        <p>
          <Text brand="legacy" size="md+">
            {text}
          </Text>
        </p>
      </a>
    </>
  )
}
